import { useCallback, useRef } from 'react';
import { DayProjectTimeEntriesFormRef } from '../components/ProjectDayTimeEntriesForm/DayProjectTimeEntriesForm';

export const useProjectEntriesValidator = () => {
  const ref = useRef<DayProjectTimeEntriesFormRef>(null);
  const validate = useCallback(
    async () => (await ref.current?.triggerValidation()) ?? true,
    [],
  );
  return { ref, validate };
};
